module.exports = __webpack_public_path__ + "static/media/fluid.1d717743.svg";